/* Happy Yay — Pumpkin Halloween Socks product section (Shopify).
   Works both standalone (static markup) and inside a Shopify product form:
   - size buttons select the matching variant (when data-opt-index is present)
   - quantity stepper keeps the hidden quantity input in sync
   - price + subtotal update live from the selected variant
   - Add to Cart posts via AJAX when a form is present; Buy It Now posts then redirects to checkout
   No dependencies. */
(function () {
  document.querySelectorAll('.hyp').forEach(function (root) {
    var form = root.querySelector('[data-hyp-form]');
    var variantInput = root.querySelector('[data-hyp-variant-id]');
    var qtyInput = root.querySelector('[data-hyp-qty-input]');
    var qtyEl = root.querySelector('#hypQty');
    var sizeName = root.querySelector('#hypSizeName');
    var priceEl = root.querySelector('[data-hyp-price]');
    var subtotalEl = root.querySelector('[data-hyp-subtotal]');
    var addBtn = root.querySelector('[data-hyp-add]');
    var mainImg = root.querySelector('#hypMainImg');
    var moneyFmt = root.getAttribute('data-money-format') || '${{amount}}';

    // Real Shopify product/variants (injected by Liquid as JSON)
    var product = null;
    try { var pj = root.querySelector('[data-hyp-product-json]'); if (pj) product = JSON.parse(pj.textContent); } catch (e) {}
    var compareEl = root.querySelector('[data-hyp-compare]');
    var saveEl = root.querySelector('[data-hyp-save]');

    function money(cents) {
      var v = (cents / 100).toFixed(2);
      return moneyFmt.replace(/\{\{\s*amount\s*\}\}/, v)
                     .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
    }

    function currentQty() { return Math.max(1, parseInt(qtyEl && qtyEl.textContent, 10) || 1); }

    function setPrice(cents) {
      if (priceEl) priceEl.textContent = money(cents);
      if (subtotalEl) subtotalEl.textContent = money(cents * currentQty());
    }

    // ---- variant picker (all options) ----
    function selectedOptions() {
      var sel = [];
      root.querySelectorAll('[data-hyp-opt]').forEach(function (g) {
        var a = g.querySelector('.hyp-size.is-active');
        sel[parseInt(g.dataset.hypOpt, 10)] = a ? a.dataset.value : null;
      });
      return sel;
    }
    function findVariant(sel) {
      return product.variants.find(function (v) { return sel.every(function (val, i) { return val == null || v.options[i] === val; }); });
    }
    function markAvailability(sel) {
      // grey out values that have no available variant with the other current choices
      root.querySelectorAll('[data-hyp-opt]').forEach(function (g) {
        var oi = parseInt(g.dataset.hypOpt, 10);
        g.querySelectorAll('.hyp-size').forEach(function (b) {
          var test = sel.slice(); test[oi] = b.dataset.value;
          var v = findVariant(test);
          b.classList.toggle('is-unavail', !v || !v.available);
        });
      });
    }
    function applyVariant(v) {
      if (!v) return;
      if (variantInput) { variantInput.value = v.id; variantInput.setAttribute('value', v.id); }
      root.dataset.price = v.price;
      setPrice(v.price);
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      if (compareEl) { compareEl.hidden = !onSale; if (onSale) compareEl.textContent = money(v.compare_at_price); }
      if (saveEl) { saveEl.hidden = !onSale; if (onSale) saveEl.textContent = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '% OFF'; }
      var img = v.featured_image && (v.featured_image.src || v.featured_image);
      if (img && mainImg) { mainImg.src = img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=900'; mainImg.removeAttribute('srcset'); }
      [addBtn, root.querySelector('[data-hyp-sticky-add]')].forEach(function (b) {
        if (!b) return; b.disabled = !v.available;
        b.textContent = v.available ? (b === addBtn ? 'Add To Cart' : 'Add to cart') : 'Sold Out';
      });
      if (window.history && history.replaceState && root.dataset.productUrl) {
        history.replaceState({}, '', root.dataset.productUrl + '?variant=' + v.id);
      }
      // tell bundle picker + theme/apps
      if (form) form.dispatchEvent(new Event('change', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
      if (window.hypExtras) window.hypExtras(root);
    }
    root.querySelectorAll('[data-hyp-opt] .hyp-size').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var g = btn.closest('[data-hyp-opt]');
        g.querySelectorAll('.hyp-size').forEach(function (b) { b.classList.remove('is-active'); b.setAttribute('aria-pressed', 'false'); });
        btn.classList.add('is-active'); btn.setAttribute('aria-pressed', 'true');
        var nm = g.querySelector('[data-hyp-opt-name]'); if (nm) nm.textContent = btn.dataset.value;
        if (!product) return;
        var sel = selectedOptions();
        var v = findVariant(sel);
        if (!v) { // combination doesn't exist: pick first variant with this value
          var oi = parseInt(g.dataset.hypOpt, 10);
          v = product.variants.find(function (x) { return x.options[oi] === btn.dataset.value && x.available; }) ||
              product.variants.find(function (x) { return x.options[oi] === btn.dataset.value; });
          if (v) root.querySelectorAll('[data-hyp-opt]').forEach(function (gg) {
            var i = parseInt(gg.dataset.hypOpt, 10);
            gg.querySelectorAll('.hyp-size').forEach(function (b) { var on = b.dataset.value === v.options[i]; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on); });
            var n = gg.querySelector('[data-hyp-opt-name]'); if (n) n.textContent = v.options[i];
          });
          sel = selectedOptions();
        }
        markAvailability(sel);
        applyVariant(v);
      });
    });
    if (product) markAvailability(selectedOptions());

    // ---- related products: Shopify recommendations (auto) ----
    var recs = root.querySelector('[data-hyp-recs]');
    if (recs && window.fetch) {
      fetch(recs.dataset.hypRecs).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var g = doc.querySelector('[data-hyp-rel-grid]');
        if (g && g.children.length) {
          recs.querySelector('[data-hyp-rel-grid]').innerHTML = g.innerHTML;
          recs.querySelectorAll('[data-hyp-reveal]').forEach(function (el) { el.classList.add('is-in'); });
        }
      }).catch(function () {});
    }

    // ---- quantity stepper ----
    root.querySelectorAll('.hyp-qty button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var q = Math.max(1, currentQty() + parseInt(btn.dataset.step, 10));
        if (qtyEl) qtyEl.textContent = q;
        if (qtyInput) qtyInput.value = q;
        // refresh subtotal against current unit price
        if (subtotalEl && priceEl) {
          var cents = parseFloat((priceEl.textContent || '0').replace(/[^0-9.]/g, '')) * 100;
          subtotalEl.textContent = money(cents * q);
        }
      });
    });

    // ---- gallery thumbnails ----
    root.querySelectorAll('.hyp-thumb').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('.hyp-thumb').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        if (mainImg && btn.dataset.full) mainImg.src = btn.dataset.full;
      });
    });

    // ---- AJAX add to cart (main item + optional gift wrap in one request) ----
    var stickyBtn = root.querySelector('[data-hyp-sticky-add]');
    function bundleInfo() {
      var hybs = root.querySelector('.hybs');
      var qty = hybs && hybs._hybsQty ? hybs._hybsQty() : (parseInt(qtyInput && qtyInput.value, 10) || 1);
      var pct = hybs && hybs._hybsPct ? hybs._hybsPct() : 0;
      var map = {}; (root.dataset.bundleCodes || '').split(',').forEach(function (p) { var kv = p.split(':'); if (kv[1]) map[kv[0].trim()] = kv[1].trim(); });
      return { qty: Math.max(1, qty), code: pct ? map[String(pct)] : '' };
    }
    function setHidden(name, val) {
      var el = form.querySelector('input[type="hidden"][name="' + name + '"]');
      if (!el) { el = document.createElement('input'); el.type = 'hidden'; el.name = name; form.appendChild(el); }
      el.value = val; return el;
    }
    function busy(on) {
      [addBtn, stickyBtn].forEach(function (b) { if (!b) return; b.disabled = on; if (on) { b.dataset.label = b.textContent; b.textContent = 'Adding…'; } else if (b.dataset.label) b.textContent = b.dataset.label; });
      if (on) root.dataset.busy = '1'; else delete root.dataset.busy;
    }
    // Native POST to /cart/add. Bypasses theme (Ella) AJAX handlers; Shopify then redirects to return_to.
    function nativeSubmit(info) {
      var q = form.querySelector('[name="quantity"]') || setHidden('quantity', info.qty); q.value = info.qty;
      var back = '/cart';
      if (info.code) back = '/discount/' + encodeURIComponent(info.code) + '?redirect=' + encodeURIComponent('/cart');
      setHidden('return_to', back);
      HTMLFormElement.prototype.submit.call(form);
    }
    function applyCartCode(code) {
      if (!code || !window.fetch) return Promise.resolve();
      return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ discount: code }) })
        .catch(function () {})
        .then(function () { return fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {}); });
    }
    function addGiftVariant() {
      var gift = root.querySelector('[data-hyp-gift]'), gv = parseInt(root.dataset.giftVariant, 10);
      if (!gift || !gift.checked || !gv || !window.fetch) return Promise.resolve();
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: gv, quantity: 1 }] }) }).catch(function(){});
    }
    function syncGiftProps() {
      var gift = root.querySelector('[data-hyp-gift]'), note = root.querySelector('[data-hyp-gift-text]');
      var on = gift && gift.checked;
      var w = form.querySelector('[name="properties[Gift wrap]"]'), n = form.querySelector('[name="properties[Gift note]"]');
      if (on) { setHidden('properties[Gift wrap]', 'Yes'); if (note && note.value.trim()) setHidden('properties[Gift note]', note.value.trim()); else if (n) n.remove(); }
      else { if (w) w.remove(); if (n) n.remove(); }
    }
    function handleAdd(e) {
      if (e) { e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation(); }
      if (root.dataset.busy || (addBtn && addBtn.hasAttribute('disabled') && !root.dataset.busy && addBtn.textContent.indexOf('Sold') >= 0)) return;
      var info = bundleInfo();
      syncGiftProps();
      busy(true);
      if (!window.fetch) { nativeSubmit(info); return; }
      if (root.dataset.afterAdd !== 'drawer') {
        var fd0 = new FormData(form); fd0.set('quantity', info.qty); fd0.delete('return_to');
        addGiftVariant()
          .then(function () { return fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd0 }); })
          .then(function (r) { if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || d.message || 'Could not add to cart.'); }); })
          .then(function () { return applyCartCode(info.code); })
          .then(function () { window.location.href = '/cart'; })
          .catch(function (err) {
            if (err && err.message && err.message !== 'Failed to fetch') { alert(err.message); busy(false); return; }
            nativeSubmit(info);
          });
        return;
      }
      // Stay-on-page mode (AJAX). Any failure falls back to the native POST.
      var fd = new FormData(form); fd.set('quantity', info.qty); fd.delete('return_to');
      addGiftVariant()
        .then(function () { return fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd }); })
        .then(function (r) { if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || d.message || 'Could not add to cart.'); }); return r.json(); })
        .then(function (res) { return applyCartCode(info.code).then(function () { return res; }); })
        .then(function (res) {
          document.dispatchEvent(new CustomEvent('hy:cart:added', { detail: res }));
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          root.dataset.cartTotal = cart.total_price;
          [addBtn, stickyBtn].forEach(function (b) { if (b) b.textContent = 'Added ✓'; });
          hyRefreshThemeCart(cart);
          setTimeout(function () { busy(false); if (window.hypExtras) window.hypExtras(root); }, 1400);
        })
        .catch(function (err) {
          console.warn('[HY] AJAX add failed, using normal form post', err);
          if (err && err.message && err.message !== 'Failed to fetch') { alert(err.message); busy(false); return; }
          nativeSubmit(info);
        });
    }
    if (form) {
      form.addEventListener('submit', handleAdd, true);            // capture: runs before theme listeners
      if (addBtn) addBtn.addEventListener('click', handleAdd, true); // Ella may bind the button click too
    }
    if (stickyBtn && form) stickyBtn.addEventListener('click', handleAdd);

  });
})();

/* Theme cart refresh: Ella (HaloThemes) + generic fallbacks */
function hyRefreshThemeCart(cart) {
  var n = cart.item_count;
  // 1) header cart count bubbles (Ella + common selectors)
  document.querySelectorAll('[data-cart-count], .cart-count, .cartCount, .cart-count-bubble span, [data-cart-item-count]').forEach(function (el) { el.textContent = n; });
  // 2) Ella: re-trigger the sidebar cart's own quantity refresh (only exists when the cart already had items)
  var q = document.querySelector('div.has-items input.item-quantity');
  if (q) { q.dispatchEvent(new Event('change', { bubbles: true })); }
  // 3) common theme events
  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  document.dispatchEvent(new CustomEvent('cart:build'));
  // 4) Ella: open the cart sidebar if its toggle exists, else fall back to the cart page
  var toggle = document.querySelector('[data-cart-sidebar], .cart-icon[data-open-cart-sidebar], a[href="/cart"][data-cart-toggle]');
  if (toggle) toggle.click();
  else if (!q) window.location.href = '/cart';
}

/* Bundle, free shipping, gift, delivery date, sticky bar */
(function () {
  function money(root, cents) {
    var f = root.getAttribute('data-money-format') || '${{amount}}';
    return f.replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2)).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  }
  function sel(root) {
    var s = root._hybs || { quantity: 1, percent: 0 };
    var unit = parseInt(root.dataset.price, 10) || 0;
    var gift = root.querySelector('[data-hyp-gift]');
    var giftOn = !!(gift && gift.checked);
    var total = Math.round(unit * s.quantity * (1 - s.percent / 100)) + (giftOn ? (parseInt(root.dataset.giftPrice, 10) || 0) : 0);
    return { qty: s.quantity, pct: s.percent, gift: giftOn, total: total };
  }
  function update(root) {
    var s = sel(root);
    var btn = root.querySelector('[data-hyp-add]');
    if (btn && !btn.disabled && !root.dataset.busy) btn.textContent = 'Add To Cart · ' + money(root, s.total);
    var sbtn = root.querySelector('[data-hyp-sticky-add]');
    if (sbtn && !sbtn.disabled && !root.dataset.busy) sbtn.textContent = 'Add · ' + money(root, s.total);
    var ship = root.querySelector('[data-hyp-ship]'), th = parseInt(root.dataset.freeShip, 10) || 0, ok = false;
    if (ship && th > 0) {
      var have = (parseInt(root.dataset.cartTotal, 10) || 0) + s.total, left = th - have;
      ok = left <= 0;
      ship.classList.toggle('is-ok', ok);
      ship.querySelector('[data-hyp-ship-text]').innerHTML = ok ? '<b>Free shipping unlocked</b> on this order' : "You're <b>" + money(root, left) + '</b> away from free shipping';
      ship.querySelector('[data-hyp-ship-bar]').style.width = Math.min(100, have / th * 100) + '%';
    }
    var sub = root.querySelector('[data-hyp-sticky-sub]');
    if (sub) sub.textContent = s.qty + ' pair' + (s.qty > 1 ? 's' : '') + (s.pct ? ' · Save ' + s.pct + '%' : '') + (s.gift ? ' · Gift wrapped' : '') + (ok ? ' · Free shipping' : '');
  }
  window.hypExtras = update;
  function addBD(d, n) { var x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w && w !== 6) n--; } return x; }
  function boot() {
    document.querySelectorAll('.hyp').forEach(function (root) {
      if (root.dataset.extras) return; root.dataset.extras = '1';
      root.addEventListener('hybs:change', function (e) { root._hybs = { quantity: e.detail.quantity, percent: e.detail.percent }; update(root); });
      var gift = root.querySelector('[data-hyp-gift]'), noteBox = root.querySelector('[data-hyp-gift-note]'), noteTxt = root.querySelector('[data-hyp-gift-text]'), cnt = root.querySelector('[data-hyp-gift-count]');
      if (gift) gift.addEventListener('change', function () { if (noteBox) noteBox.hidden = !gift.checked; update(root); });
      if (noteTxt && cnt) noteTxt.addEventListener('input', function () { cnt.textContent = noteTxt.value.length; });
      var arr = root.querySelector('[data-hyp-arrive]');
      if (arr) {
        var a1 = addBD(new Date(), parseInt(arr.dataset.min, 10) || 5), a2 = addBD(new Date(), parseInt(arr.dataset.max, 10) || 9);
        var mo = function (x) { return x.toLocaleDateString('en-US', { month: 'short' }); };
        arr.querySelector('[data-hyp-arrive-range]').textContent = mo(a1) === mo(a2) ? mo(a1) + ' ' + a1.getDate() + '–' + a2.getDate() : mo(a1) + ' ' + a1.getDate() + ' – ' + mo(a2) + ' ' + a2.getDate();
      }
      var sticky = root.querySelector('[data-hyp-sticky]'), anchor = root.querySelector('.hyp-actions');
      if (sticky && anchor) {
        var onScroll = function () {
          var r = anchor.getBoundingClientRect(), on = r.bottom < 0;
          sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        };
        window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
      }
      update(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

/* Motion: scroll reveal, live viewers, wishlist toggle */
(function () {
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function pop(el){ if(!el) return; el.classList.remove('hyp-pop'); void el.offsetWidth; el.classList.add('hyp-pop'); }
  window.hypPop = pop;
  function boot(){
    document.querySelectorAll('.hyp').forEach(function (root) {
      if (root.dataset.motion) return; root.dataset.motion = '1';
      // scroll reveal — only hides blocks below the fold; reveals anything scrolled to or past
      if (!reduce) {
        var vh = window.innerHeight;
        var pending = [].filter.call(root.querySelectorAll('[data-hyp-reveal]'), function (el) { return el.getBoundingClientRect().top > vh * 0.9; });
        if (pending.length) {
          pending.forEach(function (el) { el.classList.add('is-pending'); });
          var check = function () {
            var lim = window.innerHeight * 0.92, n = 0;
            pending = pending.filter(function (el) {
              if (el.getBoundingClientRect().top < lim) { el.style.transitionDelay = (n++ * 90) + 'ms'; el.classList.remove('is-pending'); return false; }
              return true;
            });
            if (!pending.length) { window.removeEventListener('scroll', check); window.removeEventListener('resize', check); }
          };
          window.addEventListener('scroll', check, { passive: true });
          window.addEventListener('resize', check);
          requestAnimationFrame(check);
        }
      }
      // live viewer count
      var v = root.querySelector('[data-hyp-viewers]');
      if (v) {
        var base = parseInt(v.textContent, 10) || 10, n = base;
        setInterval(function () {
          n = Math.min(base + 6, Math.max(Math.max(3, base - 3), n + [-1,1,1,-1,2,-2][Math.floor(Math.random()*6)]));
          if (String(n) !== v.textContent) { v.textContent = n; pop(v); }
        }, 4200);
      }
      // wishlist heart
      var like = root.querySelector('[data-hyp-like]');
      if (like) like.addEventListener('click', function () {
        like.setAttribute('aria-pressed', like.getAttribute('aria-pressed') === 'true' ? 'false' : 'true'); pop(like);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
